import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import { useOutsideClick } from '@hooks/useOutsideClick';
import * as React from 'react';
import { FakeButton } from '../../Buttons/Button/Button';
import { CheckboxListOption } from '../../Misc/Forms/Inputs/CheckboxList/CheckboxList';
import S from './DropdownFilter.styles';
const DropdownFilter = React.forwardRef((props, ref) => {
    const containerRef = useOutsideClick(() => props.setOpen(false));
    const optionsRef = React.useRef([]);
    return (React.createElement(S.Container, { ref: containerRef },
        React.createElement(S.Button, { id: `${props.id}-button`, ref: ref, "aria-haspopup": "listbox", "aria-expanded": props.isOpen, "aria-controls": `${props.id}-options`, onClick: () => props.setOpen(!props.isOpen), onKeyDown: (event) => {
                switch (event.key) {
                    case 'ArrowDown':
                        event.preventDefault();
                        event.stopPropagation();
                        props.setOpen(true);
                        if (optionsRef.current.length > 0) {
                            optionsRef.current[0]?.focus();
                        }
                        break;
                    case 'ArrowUp':
                        event.preventDefault();
                        event.stopPropagation();
                        props.setOpen(true);
                        if (optionsRef.current.length > 0) {
                            optionsRef.current[optionsRef.current.length - 1]?.focus();
                        }
                        break;
                    case 'ArrowRight':
                        event.preventDefault();
                        event.stopPropagation();
                        props.onRightPress();
                        break;
                    case 'ArrowLeft':
                        event.preventDefault();
                        event.stopPropagation();
                        props.onLeftPress();
                        break;
                }
            }, tabIndex: !props.canFocus ? -1 : undefined },
            React.createElement("span", null, props.translations?.['global.filters.choose']),
            props.label,
            getSvgIcon(InterfaceIcon.Chevron)),
        React.createElement(S.Options, { id: `${props.id}-options`, "aria-labelledby": `${props.id}-button`, role: "listbox", "aria-multiselectable": true },
            React.createElement(S.MobileLabel, { role: "none" }, props.label),
            React.createElement(CheckboxListOption, { ref: (el) => (optionsRef.current[0] = el), id: `dropdown-filter`, name: props.id, role: "option", value: "all", tabIndex: !props.isOpen ? -1 : undefined, checked: !props.value || props.value.length === 0, onChange: () => props.onChange?.(''), onKeyDown: (event) => handleKeyDown(event, 0), "aria-label": props.translations?.['global.filters.all'] }, props.translations?.['global.filters.all']),
            props.options.map((option, i) => (React.createElement(CheckboxListOption, { key: `${props.id}-option-${option.value}`, ref: (el) => (optionsRef.current[i + 1] = el), id: `dropdown-filter`, name: props.id, role: "option", value: option.value, tabIndex: !props.isOpen ? -1 : undefined, checked: props.value.includes(option.value), onChange: () => props.onChange?.(option.value), onKeyDown: (event) => handleKeyDown(event, i + 1), "aria-label": option.label }, option.label)))),
        React.createElement(S.BackButton, { onClick: () => props.setOpen(false), tabIndex: !props.isOpen ? -1 : undefined },
            getSvgIcon(InterfaceIcon.ArrowRight),
            " ",
            props.translations?.['global.filters.back'],
            ' ',
            React.createElement(FakeButton, { buttonType: "primary", icon: InterfaceIcon.Close, iconOnly: true }))));
    function handleKeyDown(event, i) {
        const nextIndex = i === props.options.length ? 0 : clamp(i + 1, props.options.length);
        const prevIndex = i === 0 ? props.options.length : clamp(i - 1, props.options.length);
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                event.stopPropagation();
                optionsRef.current[nextIndex]?.focus();
                break;
            case 'ArrowUp':
                event.preventDefault();
                event.stopPropagation();
                optionsRef.current[prevIndex]?.focus();
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                props.onEscapePress();
                break;
            default:
                break;
        }
    }
});
DropdownFilter.displayName = 'DropdownFilter';
export default DropdownFilter;
